import { create } from 'zustand';
import { getCategories, type Category } from '@/services/matching.service';

interface CategoryStore {
    mainCategories: Category[];
    subCategories: Category[];
    isLoading: boolean;
    error: string | null;
    fetchAllCategories: () => Promise<void>;
    getCategoryById: (id: string) => Category | undefined;
    getSubCategoriesByMainId: (mainId: string) => Category[];
}

const useCategoryStore = create<CategoryStore>((set, get) => ({
    mainCategories: [],
    subCategories: [],
    isLoading: false,
    error: null,
    fetchAllCategories: async () => {
        try {
            set({ isLoading: true, error: null });

            // 메인 카테고리와 서브 카테고리를 병렬로 조회
            const [mainCategories, subCategories] = await Promise.all([getCategories(), getCategories('SUB')]);

            set({
                mainCategories,
                subCategories,
                isLoading: false,
            });
        } catch (error) {
            set({ error: (error as Error).message, isLoading: false });
        }
    },
    getCategoryById: (id) => {
        const { mainCategories, subCategories } = get();
        return (
            mainCategories.find((cat) => cat.categoryId === id) || subCategories.find((cat) => cat.categoryId === id)
        );
    },
    getSubCategoriesByMainId: (mainId) => {
        const { subCategories } = get();
        return subCategories.filter((cat) => cat.parentCategoryId === mainId);
    },
}));

export default useCategoryStore;
